import { Box } from "@chakra-ui/react";
import Headroom from "react-headroom";
import { Banner } from "../banner";
import { Banner_T } from "../banner/banner";
import { NavContent, NavContent_T } from "../nav-content";
import { PremiumMenuDesktop, PremiumMenuProps } from "./menu";
import { PremiumMobileMenuList } from "./mobile-menu-list";

export type NavBar_T = {
  navigation: NavContent_T;
  banner?: Banner_T;
  menu: PremiumMenuProps;
};

export const PremiumNavBar = ({ banner, navigation, menu }: NavBar_T) => {
  return (
    <>
      {/* We render the banner at z level 9 and the headroom element at z level 10. */}
      <Headroom style={{ zIndex: 10 }}>
        <Box
          as="header"
          bg="white"
          shadow={{
            base: "sm",
          }}
        >
          <Box
            as="nav"
            aria-label="Main navigation"
            mx="auto"
            px={{
              sm: "4",
              md: "6",
            }}
          >
            <NavContent.Mobile {...{ links: navigation.links }}>
              <PremiumMobileMenuList routes={menu.routes} />
            </NavContent.Mobile>
            <NavContent.Desktop {...{ links: navigation.links }}>
              <PremiumMenuDesktop {...menu} />
            </NavContent.Desktop>
          </Box>
        </Box>
      </Headroom>
      {/* Add the banner outside of headroom to make it not "sticky" */}
      {banner && <Banner {...banner} zIndex="9" />}
    </>
  );
};
